<!--  -->
<template>
  <div
    :class="'header-container ' + leave"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    :style="'top:' + top + 'px;'"
  >
    <img
      src="../../static/imgs/pull.png"
      alt=""
      :class="[pullIsShow ? 'pullPng-show' : 'pullPng-hide', 'pullPng']"
      v-if="route == 'index'"
    />
    <div v-show="show" :class="'header ' + header">
      <img
        @click="navigateToMap"
        class="logo"
        src="~@/assets/HD_logo.jpg"
        alt=""
      />
      <ul class="nav1">
        <li
          @click="nav1Active(0, '', '/index')"
          :class="idx1 == 0 ? 'active1' : ''"
        >
          <span>首页</span>
        </li>
        <li
          @click="nav1Active(1, '', '/pPower')"
          :class="idx1 == 1 ? 'active1' : ''"
        >
          <span>能效云</span>
        </li>
        <li
          @click="nav1Active(2, '', '/pHot')"
          :class="idx1 == 2 ? 'active1' : ''"
        >
          <span>智慧供热</span>
        </li>
        <li
          @click="nav1Active(3, '', '/pCold')"
          :class="idx1 == 3 ? 'active1' : ''"
        >
          <span>智慧空冷</span>
        </li>
        <li
          @click="nav1Active(5, '', '/pProper')"
          :class="idx1 == 5 ? 'active1' : ''"
        >
          <span>云城智慧平台</span>
        </li>
        <!--  <li
          @click="nav1Active(6, '', '/news')"
          :class="idx1 == 6 ? 'active1' : ''"
        >
          <span>混沌新闻</span>
        </li> -->
        <li
          :class="idx1 == 4 ? 'active1' : ''"
          @mouseenter="naventer(4)"
          @mouseleave="navleave(4)"
        >
          <span :class="idx1 == 4 ? 'active1' : ''">关于我们</span>
          <div :class="hoverIndex == 4 ? 'nav2 active' : 'nav2'">
            <ul>
              <li
                @click="nav1Active(4, 0, '/about')"
                :class="idx2 == 0 ? 'active2' : ''"
              >
                <span>关于我们</span>
              </li>
              <li
                @click="nav1Active(4, 1, '/recruit')"
                :class="idx2 == 1 ? 'active2' : ''"
              >
                <span>公司招聘</span>
              </li>
              <li
                @click="nav1Active(4, 2, '/news')"
                :class="idx2 == 2 ? 'active2' : ''"
              >
                <span>混沌新闻</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="contactGroup">
        <!-- 1:{{realName}}2:{{realName1}}3: {{visitorPhone}} 4: {{visitorPhone1}} -->
        <template
          v-if="!realName && !realName1 && !visitorPhone && !visitorPhone1"
        >
          <div slot="reference" class="login-user-msg" @click="goControlLogin">
            <img src="../../static/imgs/user.png" alt="" class="user-img" />
            <span class="loginWord">控制台</span>
          </div>
        </template>
        <template v-else-if="realName || realName1">
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="main-popper"
            @show="showPopover"
            @hide="hidePopover"
          >
            <template v-if="realName">
              <div
                class="login-item login-edit"
                v-for="(it, index) in platformNameList"
                :key="index"
                @click="jumpTo(it.platformCode, it.platformUrl)"
              >
                <i class="iconfont iconlock"></i>
                {{ it.platformName }}
              </div>
            </template>
            <template v-else>
              <div
                class="login-item login-edit"
                v-for="(it, index) in platformNameList1"
                :key="index"
                @click="jumpTo(it.platformCode, it.platformUrl)"
              >
                <i class="iconfont iconlock"></i>
                {{ it.platformName }}
              </div>
            </template>
            <div class="login-item logOut" @click="logOut">
              <i class="iconfont iconlogout"></i>
              退出登录
            </div>
            <div slot="reference" class="login-user-msg">
              <!-- <img src="../../static/imgs/user.png" alt="" class="user-img"> -->
              <span class="controlUsername" v-if="realName"
                >您好，{{ realName }}</span
              >
              <span class="controlUsername" v-else-if="realName1"
                >您好，{{ realName1 }}</span
              >
            </div>
          </el-popover>
        </template>
        <template v-else-if="visitorPhone || visitorPhone1">
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="main-popper"
            @show="showPopover"
            @hide="hidePopover"
          >
            <div class="login-item logOut" @click="logOut">
              <i class="iconfont iconlogout"></i>
              退出登录
            </div>
            <div slot="reference" class="login-user-msg">
              <!-- 1--{{visitorPhone}}2--{{visitorPhone1}} -->
              <!-- <img src="../../static/imgs/user.png" alt="" class="user-img"> -->
              <span class="controlUsername" v-if="visitorPhone"
                >您好，{{ visitorPhone }}</span
              >
              <span class="controlUsername" v-else-if="visitorPhone1"
                >您好，{{ visitorPhone1 }}</span
              >
            </div>
          </el-popover>
        </template>
        <span class="contact" @click="nav1Active(-1, '', '/contactUs')"
          >联系我们</span
        >
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { setToken, getCookie } from "../libs/auth.js";
import { loginOut } from "@/api/login.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      pullIsShow: true,
      header: "",
      clientWidth: "",
      clientHeight: "",
      containerHeight: "",
      height: "",
      top: "",
      show: true,
      activeIndex: "1",
      idx1: "",
      idx2: "",
      hoverIndex: "",
      leave: "leave",
      route: "",
      controlHasLogin: false,
      controlUsername: "",
      platformNameList1: [],
      visitorPhone1: "",
      realName1: "",
      isHide: true
    };
  },
  //监听属性 类似于data概念
  computed: {
    // ...mapState(["userInfo"]),
    // ...mapState(["hasLogin"]),
    realName() {
      return this.$store.state.realName;
    },
    platformNameList() {
      return this.$store.state.platformNameList;
    },
    visitorPhone() {
      return this.$store.state.visitorPhone;
    }
  },

  //监控data中的数据变化
  watch: {
    $route(to, from) {
      // console.log(to,from)
      let url = to.matched[0].name;
      //debugger;
      this.route = to.name;
      if (to.path == "/login" || url == "back") {
        this.show = false;
      } else {
        switch (to.name) {
          case "index":
            this.idx1 = 0;
            this.header = "";
            this.leave = "leave";
            if (this.clientHeight < this.containerHeight) {
              this.top = 0;
            } else {
              this.top = (this.clientHeight - this.containerHeight) / 2;
            }
            break;
          case "news":
            this.idx1 = 4;
            this.header = "header0";
            this.leave = "";
            this.top = 0;
            this.idx2 = 2;
            break;
          case "about":
            this.idx1 = 4;
            this.idx2 = 0;
            this.header = "header0";
            this.leave = "";
            this.top = 0;
          default:
            this.header = "header0";
            this.leave = "";
            this.top = 0;
            break;
        }
        this.show = true;
        this.height = "";
        sessionStorage.setItem("navIdx1", this.idx1);
        sessionStorage.setItem("navIdx2", this.idx2);
      }
    }
  },

  //方法集合
  methods: {
    showPopover() {
      this.isHide = false;
    },
    hidePopover() {
      this.isHide = true;
      this.leave = "leave";
      this.pullIsShow = true;
      if (this.idx1 == 0) {
        this.header = "";
      }
    },
    mouseenter() {
      this.header = "header0";
      this.leave = "";
      this.pullIsShow = false;
    },
    mouseleave() {
      if (this.route == "index" && this.isHide) {
        this.header = "";
        this.leave = "leave";
        this.pullIsShow = true;
      }
      //this.top= -46
    },
    toLogin() {
      this.$router.push({ path: "/login" });
    },
    nav1Active(idx1, idx2, route) {
      this.idx1 = idx1;
      this.idx2 = idx2;
      this.$router.push({ path: route });
      if (route == "/index" && this.route != "index") {
        this.pullIsShow = true;
      }
    },
    naventer(idx) {
      this.hoverIndex = idx;
    },
    navleave() {
      this.hoverIndex = "";
    },
    logOut() {
      loginOut().then(res => {
        setToken("");
        this.isHide = true;
        this.realName1 = "";
        this.visitorPhone1 = "";
        this.platformNameList1 = [];
        window.localStorage.removeItem("oauthToken");
        window.localStorage.removeItem("videoToken");
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("platformNameList");
        window.localStorage.removeItem("realName");
        window.localStorage.removeItem("visitorPhone");
        window.localStorage.removeItem("userDetailInfo");
        window.localStorage.removeItem("userInfo");
        window.sessionStorage.removeItem("userInfo");
        this.$store.commit("update", ["realName", ""]);
        this.$store.commit("update", ["platformNameList", []]);
        this.$store.commit("update", ["visitorPhone", ""]);
      });
    },
    navigateToMap() {
      this.$router.push({ path: "/map" });
    },
    goControlLogin() {
      this.$router.push({ path: "/controlLogin" });
    },
    jumpTo(platformCode, platformUrl) {
      // menusMap   privilegeFunctionPointsMap  appCode 跳转锅炉云以及中台会乱跳需要清除
      localStorage.removeItem("menusMap");
      localStorage.removeItem("privilegeFunctionPointsMap");
      localStorage.removeItem("appCode");
      // if (platformCode == "kongleng") {
      //   window.open(
      //     "http://47.103.133.175/air-cooling/index.html#/login?userCode=guest&password=Slzs@123456"
      //   );
      // } else
      if (platformUrl) {
        if (platformCode) {
          localStorage.setItem("platformCode", "zhongtai");
        } else {
          localStorage.removeItem("platformCode");
        }
        if (
          platformCode === "biaozhunnengyuanzhan" ||
          platformCode === "zhongtai" ||
          platformCode === "guoluyun"
        ) {
          const domain =
            process.env.NODE_ENV === "development"
              ? "http://localhost:3000"
              : location.origin;

          window.open(domain + "/wonder/redirect", "_blank");
        } else {
          if (
            platformUrl.split("://")[0] == "http" ||
            platformUrl.split("://")[0] == "https"
          ) {
            window.open(platformUrl, "_blank");
          } else {
            let jumpUrl = location.origin + platformUrl;
            window.open(jumpUrl, "_blank");
          }
        }
      }
    },
    findIndexOf(d, str) {
      return d.findIndex(item => item.code === str);
    }
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //debugger;
    let that = this;
    this.clientHeight = document.documentElement.clientHeight;
    this.clientWidth = document.documentElement.clientWidth;
    this.containerHeight = (1080 / 1920) * this.clientWidth;
    if (this.clientHeight < this.containerHeight) {
      this.top = 0;
    } else {
      this.top = (this.clientHeight - this.containerHeight) / 2;
    }
    //console.log(this.$route.path);
    this.idx1 = sessionStorage.getItem("navIdx1");
    this.idx2 = sessionStorage.getItem("navIdx2");
    // 控制台用户的信息
    this.controlUsername = getCookie("username");
    // 获取用户下的平台
    this.platformNameList1 = JSON.parse(
      window.localStorage.getItem("platformNameList")
    );
    this.realName1 = window.localStorage.getItem("realName");
    this.visitorPhone1 = window.localStorage.getItem("visitorPhone");
  },

  //生命周期 - 创建之前
  beforeCreate() {},

  //生命周期 - 挂载之前
  beforeMount() {},

  //生命周期 - 更新之前
  beforeUpdate() {},

  //生命周期 - 更新之后
  updated() {},

  //生命周期 - 销毁之前
  beforeDestroy() {},

  //生命周期 - 销毁完成
  destroyed() {},

  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {}
};
</script>
<style lang="less">
//@import url(); 引入公共css类
.el-popover {
  min-width: 80px;
}
.main-popper {
  width: 140px;
  padding: 0;
}
.login-item {
  cursor: pointer;
  width: 100%;
  text-align: center;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  border-bottom: 1px solid #f6f6f8;
  &.logOut {
    color: #006bff;
  }
}
.leave {
  overflow: hidden;
}
.header-container {
  position: fixed;
  z-index: 19;
  height: 59px;
  width: 100%;
  box-sizing: border-box;
  .pullPng {
    position: fixed;
    left: 50%;
    top: 0px;
    padding-top: 20px;
    transform: translateX(-50%);
    cursor: pointer;
    &.pullPng-show {
      // opacity: 1;
      transition: 1s;
      top: 0px;
    }
    &.pullPng-hide {
      // opacity: 0;
      // display: none;
      transition: 1s;
      top: 60px;
    }
  }
  /* overflow: hidden; */
  .header {
    position: absolute;
    background: #fff;
    height: 100%;
    width: 100%;
    top: -59px;
    transition: 1s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    border-bottom: 1px solid #f6f6f8;
    .logo {
      cursor: pointer;
      width: 62px;
    }
    .contactGroup {
      display: flex;
      height: 100%;
      cursor: pointer;
      align-items: center;
      .login-user-msg {
        display: flex;
        align-items: center;
        span {
          color: rgba(0, 0, 0, 0.75);
        }
        .controlUsername {
          font-size: 14px;
        }
      }
      .user-img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
      .loginWord {
        color: #494949;
      }
      .loginAndLogOut {
        display: flex;
        height: 100%;
        color: #494949;
        font-size: 12px;
        align-items: center;
        justify-content: center;
        padding: 0px 40px;
      }
      .contact {
        display: inline-block;
        padding: 8px 40px;
        font-size: 13px;
        color: #3d3d3d;
        font-weight: 600;
        border: 2px solid #282828;
        margin-left: 33px;
        margin-right: 41px;
      }
    }
    .nav1 {
      display: flex;
      list-style: none;
      height: 100%;
      align-items: center;
      > li {
        padding: 0 32px;
        height: 100%;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        > span {
          display: inline-block;
          color: #242424;
          font-size: 14px;
          border-bottom: 2px solid transparent;
          padding: 4px 0;
        }
        .nav2 {
          position: absolute;
          top: 100%;
          left: -130px;
          height: 0px;
          transition: 0.3s;
          overflow: hidden;
          > ul {
            padding-left: 0px;
            left: -50%;
            height: 59px;
            display: flex;
            align-items: center;
            background: #f7f8fa;
            box-shadow: 4px 4px 4px rgba(224, 224, 224, 0.15);
            width: 400px;
            justify-content: space-around;
            li {
              list-style: none;
              white-space: nowrap;
              display: flex;
              justify-content: center;
              height: 100%;
              width: 100px;
              align-items: center;
              color: #9a9a9a;
            }
          }
        }
        .active {
          height: 59px;
          transition: 0.3s;
        }
      }
      .active1 {
        > span {
          border-bottom: 2px solid #006bff;
        }
        .active2 {
          color: #006bff;
        }
      }
    }
  }
  .header0 {
    top: 0px;
    transition: 1s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue